export default __webpack_public_path__ + "static/media/stars.cc71c615.svg";